import { Navigate } from "react-router-dom";

function RutaPrivada({ children, rolesPermitidos = [] }) {

    const usuario = JSON.parse(localStorage.getItem("usuario"));

    if (!usuario) {
        return <Navigate to="/login" />;
    }

    if (
        rolesPermitidos.length > 0 &&
        !rolesPermitidos.includes(Number(usuario.rol))
    ) {
        return <Navigate to="/" />;
    }

    return children;
}

export default RutaPrivada;